<template>
  <div class="aw-page">
    <HeadNav selectedLanguage="en" page="blogs" />
    <main>
      <article v-if="post" class="content-section blog-post">
        <p class="blog-post__crumb">
          <router-link :to="{ name: 'blogs' }">Blogs</router-link>
          <span aria-hidden="true"> / </span>
          <span>{{ post.title }}</span>
        </p>

        <h1>{{ post.heading || post.title }}</h1>
        <time v-if="post.date" class="blog-post__date" :datetime="post.publishedAt">{{ post.date }}</time>

        <figure v-if="post.cover" class="blog-post__cover content-figure">
          <img
            :src="post.cover"
            :alt="post.coverAlt || post.title"
            width="1230"
            height="819"
            loading="eager"
          >
        </figure>

        <div class="blog-post__body">
          <template v-for="(block, i) in post.sections">
            <h2 v-if="block.type === 'h2'" :key="'h2-' + i">{{ block.text }}</h2>
            <p v-else-if="block.type === 'p'" :key="'p-' + i" v-html="block.html" />
            <ol v-else-if="block.type === 'ol'" :key="'ol-' + i" class="guide-steps">
              <li v-for="(item, j) in block.items" :key="j">
                <span class="guide-steps__num" aria-hidden="true">{{ j + 1 }}</span>
                <span class="guide-steps__text" v-html="item" />
              </li>
            </ol>
            <ul v-else-if="block.type === 'ul'" :key="'ul-' + i">
              <li v-for="(item, j) in block.items" :key="j" v-html="item" />
            </ul>
          </template>
        </div>

        <nav class="blog-pager" aria-label="Blog post navigation">
          <router-link
            v-if="neighbors.prev"
            class="blog-pager__link"
            :to="{ name: 'blog-post', params: { slug: neighbors.prev.slug } }"
          >
            <span class="blog-pager__label">Previous</span>
            <span class="blog-pager__title">{{ neighbors.prev.title }}</span>
          </router-link>
          <span v-else class="blog-pager__placeholder" />

          <router-link
            v-if="neighbors.next"
            class="blog-pager__link blog-pager__link--next"
            :to="{ name: 'blog-post', params: { slug: neighbors.next.slug } }"
          >
            <span class="blog-pager__label">Next</span>
            <span class="blog-pager__title">{{ neighbors.next.title }}</span>
          </router-link>
          <span v-else class="blog-pager__placeholder" />
        </nav>
      </article>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/site.scss';
import HeadNav from '@/components/HeadNav.vue';
import { getBlogPost, getBlogNeighbors } from '@/content/blogs';

export default {
  name: 'BlogPost',
  components: { HeadNav },
  computed: {
    post() {
      return getBlogPost(this.$route.params.slug);
    },
    neighbors() {
      return getBlogNeighbors(this.$route.params.slug);
    },
  },
};
</script>
